import { Form } from "antd";
import PhoneInput from "antd-phone-input";

const InputPhoneNumber = ({ rules, label, name, onChange }) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <PhoneInput
        onChange={(e) => onChange?.(name, e)}
        enableSearch
      />
    </Form.Item>
  );
};

export default InputPhoneNumber;
